import React from "react";
import { ensure } from "sprint-common-web";

import { OrderCompletionProgressInfo } from "../../../../common/components/listings/OrderCompletionProgressInfo";
import { OrderRequestListingItem } from "../../OrderRequestListingItem";

export const renderOrderRequestProgress = (item?: OrderRequestListingItem): JSX.Element => {
    ensure(item);

    return (
        <OrderCompletionProgressInfo
            text="Cloud"
            progress={item.progress.cloud}
            key={`${item.id}-cloud-progress`}
            testId="order-request-completion-progress"
        />
    );
};
